import { Assets } from '@air/api';
import { skipToken, useQuery } from '@tanstack/react-query';

import { callAirApi } from '~/swr-hooks/callAirApi';

export const ASSET_VERSION_CHAPTERS_LIST_KEY = 'ASSET_VERSION_CHAPTERS_LIST';

export type UseAssetVersionChaptersListParams = {
  workspaceId: string | undefined;
  assetId: string | undefined;
  clipId: string | undefined;
};

export const getAssetVersionChaptersListKey = (params?: UseAssetVersionChaptersListParams) => {
  return [ASSET_VERSION_CHAPTERS_LIST_KEY, params];
};

export type UseAssetVersionChaptersOptions = {
  enabled?: boolean;
};

export type Chapter = {
  title: string;
  startTime: number;
  endTime: number;
  summary: string;
};

type ChapterResponse = {
  data: Chapter[];
};

export const useAssetVersionChaptersList = (
  params: UseAssetVersionChaptersListParams,
  options: UseAssetVersionChaptersOptions = { enabled: true },
) => {
  const { workspaceId, assetId, clipId } = params;

  return useQuery<ChapterResponse, Error, Chapter[]>({
    queryKey: getAssetVersionChaptersListKey(params),
    queryFn:
      workspaceId && assetId && clipId
        ? async () => {
            return callAirApi<ChapterResponse>(() =>
              Assets.Versions.Chapters.list({
                workspaceId,
                assetId,
                clipId,
              }),
            );
          }
        : skipToken,
    select: (data) => data!.data || [],
    enabled: !!workspaceId && !!assetId && !!clipId && options.enabled,
  });
};
